import type { RouteObject } from 'react-router';
import { ModuleRoute } from '@/components/guards';

/** Rotas deste módulo, montadas dentro do layout do painel (caminhos relativos). */
export const financeRoutes: RouteObject[] = [
  {
    path: 'financeiro',
    element: <ModuleRoute module="finance" permission="finance:read" />,
    children: [
      {
        lazy: async () => ({ Component: (await import('./layout')).FinanceLayout }),
        children: [
          { index: true, lazy: async () => ({ Component: (await import('./summary')).FinanceSummaryPage }) },
          { path: 'lancamentos', lazy: async () => ({ Component: (await import('./transactions')).TransactionsPage }) },
          { path: 'fixas', lazy: async () => ({ Component: (await import('./recurring')).RecurringPage }) },
          { path: 'fluxo', lazy: async () => ({ Component: (await import('./cashflow')).CashflowPage }) },
          { path: 'dre', lazy: async () => ({ Component: (await import('./dre')).DrePage }) },
          { path: 'calculadora', lazy: async () => ({ Component: (await import('./calculator')).PriceCalculatorPage }) },
          { path: 'mei', lazy: async () => ({ Component: (await import('./mei')).MeiPage }) },
        ],
      },
    ],
  },
];
